import React from "react";

import { Avatar, Box, Typography } from "@mui/material";
import { makeStyles, withStyles } from "tss-react/mui";

import { graphql } from "@/gql";
import { useFragment } from "@/hooks/useFragment";
import { colors } from "@/theme/overrides/colors";

interface Props {
  id: string;
}

const useStyles = makeStyles()(() => ({
  root: {
    display: "flex",
    width: "100%",
    marginBottom: 14,
    backgroundColor: colors.white,
    padding: 14,
  },
  profileInfo: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
  },
}));

const StyledAvatar = withStyles(Avatar, {
  root: {
    marginRight: 10,
  },
});

export const strugglingClientCardFragment = graphql(`
  fragment StrugglingClientCard on Client {
    id
    profile {
      id
      fullName
      avatarUrl(variant: THUMB)
    }
  }
`);

const StrugglingClientCard: React.FC<Props> = ({ id }) => {
  const { classes } = useStyles();

  const [client] = useFragment(strugglingClientCardFragment, `Client:${id}`);

  return (
    <Box className={classes.root}>
      <Box className={classes.profileInfo}>
        <StyledAvatar src={client?.profile?.avatarUrl ?? undefined} />
        <Typography variant="body1">{client?.profile?.fullName}</Typography>
      </Box>
    </Box>
  );
};

export default StrugglingClientCard;
